var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fo-header',{attrs:{"selected":"/about"},on:{"selected":function (e) {}}}),_vm._v(" "),_vm._l((_vm.modelData),function(item,ind){return [_c(item.model_name,{key:ind,tag:"component",attrs:{"itemData":item}})]}),_vm._v(" "),_c('fo-footer')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aec7faaa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = null
// module chunks = 